interface Sentence {
  original: string;
  french: string;
  // English translation of `french`, optional; falls back to `french` when absent.
  english?: string;
  words: string[];
  audio?: string;
  category: string;
  tags: string[];
}

export const SENTENCE_CATEGORIES = {
  'Salutations': {
    icon: '👋',
    description: 'Premiers contacts et formules de politesse',
  },
  'Présentation': {
    icon: '🤝',
    description: 'Se présenter et faire connaissance',
  },
  'Vie quotidienne': {
    icon: '🌞',
    description: 'Expressions du quotidien',
  },
  'Au marché': {
    icon: '🛍️',
    description: 'Faire ses courses et négocier',
  },
  'Voyages': {
    icon: '✈️',
    description: 'Se déplacer et visiter',
  },
  'Famille et relations': {
    icon: '👨‍👩‍👧‍👦',
    description: 'Parler de sa famille et de ses proches',
  },
  'Urgences et santé': {
    icon: '🏥',
    description: 'Situations d\'urgence et santé',
  },
  'Loisirs et culture': {
    icon: '🎭',
    description: 'Loisirs, culture et activités',
  },
} as const;

export const sentencesToConstruct: Sentence[] = [
  // Salutations
  {
    original: "I ni ce",
    french: "Bonjour",
    english: "Hello",
    words: ["I", "ni", "ce"],
    audio: "Ba-I_ni_ce",
    category: 'Salutations',
    tags: ['salutations', 'quotidien']
  },
  {
    original: "A ni ce",
    french: "Bonjour",
    english: "Hello",
    words: ["A", "ni", "ce"],
    audio: "Ba-A_ni_ce",
    category: 'Salutations',
    tags: ['salutations', 'quotidien']
  },
  {
    original: "U ka kɛnɛ",
    french: "Ils vont bien",
    english: "They are doing well",
    words: ["U", "ka", "kɛnɛ"],
    audio: "Ba-U_ka_kene",
    category: 'Salutations',
    tags: ['salutations', 'réponse']
  },
  {
    original: "I ni sogoma",
    french: "Bonjour (matin)",
    english: "Good morning",
    words: ["I", "ni", "sogoma"],
    audio: "Ba-I_ni_sogoma",
    category: 'Salutations',
    tags: ['salutations', 'matin']
  },
  {
    original: "I ni tile",
    french: "Bonjour (midi)",
    english: "Good afternoon",
    words: ["I", "ni", "tile"],
    audio: "Ba-I_ni_tile",
    category: 'Salutations',
    tags: ['salutations', 'midi']
  },
  {
    original: "I ni su",
    french: "Bonsoir",
    english: "Good evening",
    words: ["I", "ni", "su"],
    audio: "Ba-I_ni_su",
    category: 'Salutations',
    tags: ['salutations', 'soir']
  },
  {
    original: "A ka san",
    french: "Bonne journée",
    english: "Have a good day",
    words: ["A", "ka", "san"],
    audio: "Ba-A_ka_san",
    category: 'Salutations',
    tags: ['au revoir', 'politesse']
  },
  {
    original: "I ka kɛnɛ ?",
    french: "Comment vas-tu ?",
    english: "How are you?",
    words: ["I", "ka", "kɛnɛ", "?"],
    category: 'Salutations',
    tags: ['salutations', 'question']
  },
  {
    original: "An kɛlɛma",
    french: "Au revoir",
    english: "Goodbye",
    words: ["An", "kɛlɛma"],
    audio: "Ba-An_kelema",
    category: 'Salutations',
    tags: ['au revoir', 'politesse']
  },


   {
    original: "N ka kɛnɛ kosɔbɛ",
    french: "Je vais bien",
    english: "I am doing well",
    words: ["N", "ka", "kɛnɛ", "kosɔbɛ"],
    audio: "Ba-N_ka_kene_Kosobe",
    category: 'Salutations',
    tags: ['salutations', 'réponse']
  },


  {
    original: "Hɛrɛ dɔrɔn",
    french: "Totalement en paix",
    english: "Completely at peace",
    words: ["Hɛrɛ", "dɔrɔn"],
    audio: "Ba-Heere_doron",
    category: 'Salutations',
    tags: ['salutations', 'réponse']
  },


   {
    original: "Baasi foyi te yen",
    french: "Il n'ya pas de problème",
    english: "There's no problem",
    words: ["Baasi", "foyi", "te", "yen"],
    audio: "Ba-Baasi_foyi_te_yen",
    category: 'Salutations',
    tags: ['salutations', 'réponse']
  },


   {
    original: "N man kenɛ ",
    french: "Je ne vais pas bien",
    english: "I am not doing well",
    words: ["N", "man", "kenɛ", " "],
    audio: "Ba-N_man_kene",
    category: 'Salutations',
    tags: ['salutations', 'réponse']
  },

   {
    original: "N fari be dimina",
    french: "Je suis malade",
    english: "I am sick",
    words: ["N", "fari", "be", "dimina"],
    audio: "Ba-N_fari_be_dimina",
    category: 'Salutations',
    tags: ['salutations', 'réponse']
  },


   {
    original: "I ka kuma ka teli",
    french: "Tu parles rapidement",
    english: "You speak quickly",
    words: ["I", "ka", "kuma", "ka", "teli"],
    audio: "Ba-I_ka_kuma_ka_teli",
    category: 'Salutations',
    tags: ['salutations', 'réponse']
  },


  {
    original: "Sisan n y'a faamu",
    french: "Maintenant, j'ai compris",
    english: "Now I understand",
    words: ["Sisan", "n", "y'a", "faamu"],
    audio: "Ba-Sisan_n_ya_faamu",
    category: 'Salutations',
    tags: ['salutations', 'réponse']
  },


  {
    original: "I tɔgɔ ye mun ye?",
    french: "Quel est ton nom?",
    english: "What is your name?",
    words: ["I", "tɔgɔ", "ye", "mun", "ye", "?"],
    audio: "Ba-I_togo_ye_mun_ye",
    category: 'Présentation',
    tags: ['présentation', 'question']
  },


  {
    original: "A be sɛbɛn cogo di ?",
    french: "Quel est ton nom ?",
    english: "What is your name?",
    words: ["A", "be", "sɛbɛn", "cogo", "di", "?"],
    audio: "Ba-A_be_seben_cogo_di",
    category: 'Présentation',
    tags: ['présentation', 'question']
  },

   {
    original: "I nana cogo juman ?",
    french: "Comment es-tu venu ?",
    english: "How did you come?",
    words: ["I", "nana", "cogo", "juman", "?"],
    audio: "Ba-I_nana_cogo_juman",
    category: 'Présentation',
    tags: ['présentation', 'question']
  },

  {
    original: "N nana nɛgɛso le ye",
    french: "C'est à vélo que je suis venu",
    english: "I came by bicycle",
    words: ["N", "nana", "nɛgɛso", "le", "ye"],
    audio: "Ba-N_nana_negeso_le_ye",
    category: 'Présentation',
    tags: ['présentation', 'question']
  },
  {
    original: "N tɔgɔ Yero",
    french: "Je m'appelle Yero",
    english: "My name is Yero",
    words: ["N", "tɔgɔ","Yero"],
    audio: "Ba-N_togo_Yero",
    category: 'Présentation',
    tags: ['présentation', 'réponse']
  },
  {
    original: "I bɛ bɔ min?",
    french: "D'où viens-tu?",
    english: "Where are you from?",
    words: ["I", "bɛ", "bɔ", "min", "?"],
    audio: "Ba-I_be_bo_min",
    category: 'Présentation',
    tags: ['présentation', 'origine', 'question']
  },
  {
    original: "N bɛ bɔ Bamako",
    french: "Je viens de Bamako",
    english: "I am from Bamako",
    words: ["N", "bɛ", "bɔ", "Bamako"],
    audio: "Ba-N_be_bo_bamako",
    category: 'Présentation',
    tags: ['présentation', 'origine', 'réponse']
  },
  {
    original: "I ka san joli ye?",
    french: "Quel âge as-tu?",
    english: "How old are you?",
    words: ["I", "ka", "san", "joli","ye", "?"],
    audio: "Ba-I_ka_san_joli_ye",
    category: 'Présentation',
    tags: ['présentation', 'âge', 'question']
  },
  {
    original: "N ka san mugan ye",
    french: "J'ai vingt ans",
    english: "I am twenty years old",
    words: ["N", "ka", "san", "mugan", "ye"],
    audio: "Ba-N_ka_san_mugan_ye",
    category: 'Présentation',
    tags: ['présentation', 'âge', 'réponse']
  },

  // Présentation 

  {
    original: "N bɔɔra baarakɛyɔrɔ la",
    french: "Je viens du bureau",
    english: "I'm coming from the office",
    words: ["N", "bɔɔra", "baarakɛyɔrɔ", "la"],
    audio: "Ba-N_boora_baarakeyoro_la",
    category: 'Présentation',
    tags: ['nom', 'présentation']
  },
  {
    original: "I ka luu be min ?",
    french: "Où habites-tu ?",
    english: "Where do you live?",
    words: ["I", "ka", "luu", "be","min","?"],
    audio: "Ba-I_ka_luu_be_min",
    category: 'Présentation',
    tags: ['nom', 'présentation']
  },

   {
    original: "I ka so be min ?",
    french: "Où habites-tu ?",
    english: "Where do you live?",
    words: ["I", "ka", "so", "be","min","?"],
    audio: "Ba-I_ka_so_be_min",
    category: 'Présentation',
    tags: ['nom', 'présentation']
  },

  {
    original: "N ka so be Yankadi",
    french: "Ma maison est à Yankadi",
    english: "My house is in Yankadi",
    words: ["N", "ka", "so", "be","Yankadi"],
    audio : "Ba-N_ka_so_be_Yankadi",
      category : 'Présentation',
    tags : ['présentation', 'question']
  },

   {
    original: "N ka luu be Yankadi",
    french: "Ma maison est à Yankadi",
    english: "My house is in Yankadi",
    words: ["N", "ka", "luu", "be","Yankadi"],
    audio : "Ba-N_ka_luu_be_yankadi",
      category : 'Présentation',
    tags : ['présentation', 'question']
  },

  {
    original: "I togo be di ?",
    french: "Comment t'appelles-tu ?",
    english: "What is your name?",
    words: ["I", "togo", "be", "di", "?"],
    audio: "Ba-I_togo_be_di",
    category: 'Présentation',
    tags: ['présentation', 'question']
  },

   {
    original: "Somogow be di ?",
    french: "Comment vont les gens à la maison ?",
    english: "How is everyone at home?",
    words: ["Somogow", "be", "di", "?"],
    audio: "Ba-Somogow_be_di",
    category: 'Présentation',
    tags: ['présentation', 'question']
  },


   {
    original: "Sunogo b'i la wa ?",
    french: "As-tu sommeil ?",
    english: "Are you sleepy?",
    words: ["Sunogo", "b'i", "la", "wa", "?"],
    audio: "Ba-Sunogo_bi_la_wa",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },

  {
    original: "I be fe ka la wa ?",
    french: "Veux-tu dormir ?",
    english: "Do you want to sleep?",
    words: ["I", "be", "fe", "ka", "la", "wa", "?"],
    audio: "Ba-I_be_fe_ka_la_wa",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },


   {
    original: "Minɔgɔ bɛ n na",
    french: "J'ai soif",
    english: "I am thirsty",
    words: ["Minɔgɔ", "bɛ", "n", "na"],
    audio: "Ba-Minogo_be_n_na",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },

   {
    original: "I sigenna wa ?",
    french: "Es-tu fatigué ?",
    english: "Are you tired?",
    words: ["I", "sigenna", "wa", "?"],
    audio: "Ba-I_sigenna_wa",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },


  {
    original: "So jɛlen don ",
    french: "La maison est propre",
    english: "The house is clean",
    words: ["So", "jɛlen", "don"],
    audio: "Ba-So_jelen_don",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'description']
  },

  {
    original: "N bɛ kɔgɔ fɛ",
    french: "Je veux du sel",
    english: "I want some salt",
    words: ["N", "be", "kɔgɔ", "fɛ"],
    audio: "Ba-N_be_kogo_fe",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'description']
  },

   {
    original: "I be fe ka sigi wa ?",
    french: "Veux-tu t'assoir ?",
    english: "Do you want to sit down?",
    words: ["I", "be", "fe", "ka", "sigi", "wa", "?"],
    audio: "Ba-I_be_fe_ka_sigi_wa",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },


  {
    original: "I be deme fe wa ?",
    french: "As-tu besoin d'aide ?",
    english: "Do you need help?",
    words: ["I", "be", "deme", "fe", "wa", "?"],
    audio: "Ba-I_be_deme_fe_wa",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },


    {
    original: "I be siran wa ?",
    french: "As-tu peur ?",
    english: "Are you afraid?",
    words: ["I", "be", "siran", "wa", "?"],
    audio: "Ba-I_be_siran_wa",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },

  {
    original: "K'i bila sira wa ?",
    french: "Veux-tu que je t'accompagnes ?",
    english: "Do you want me to go with you?",
    words: ["K'i", "bila", "sira", "wa", "?"],
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },


   {
    original: "Minɔgɔ b'i la wa?",
    french: "As-tu soif ?",
    english: "Are you thirsty?",
    words: ["Minɔgɔ", "b'i", "la", "wa", "?"],
    audio: "Ba-Minogo_bi_la_wa",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },

    {
    original: "Kɔngɔ b'i la wa ?",
    french: "As-tu faim ?",
    english: "Are you hungry?",
    words: ["Kɔngɔ", "b'i", "la", "wa", "?"],
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },


   {
    original: "Nene b'i la wa?",
    french: "As-tu froid ?",
    english: "Are you cold?",
    words: ["Nene", "b'i", "la", "wa", "?"],
    audio: "Ba-Nene_bi_la_wa",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },

   {
    original: "Taatuma sera",
    french: "C'est l'heure de partir",
    english: "It's time to go",
    words: ["Taatuma", "sera"],
    audio: "Ba-Taatuma_sera",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },

   {
    original: "Funteni b'i la wa ?",
    french: "As-tu chaud ?",
    english: "Are you hot?",
    words: ["Funteni", "b'i", "la", "wa", "?"],
    audio: "Ba-Funteni_bi_la_wa",
    category: 'Vie quotidienne',
    tags: ['vie quotidienne', 'question']
  },


    {
    original: "U be ka kene",
    french: "Ils vont bien",
    english: "They are doing well",
    words: ["U", "be", "ka", "kene"],
    audio: "Ba-U_be_ka_kene",
    category: 'Présentation',
    tags: ['présentation', 'question']
  },
  
 
  {
    original: "I bɛ bɔ dugukolo min na ?",
    french: "D'où viens-tu ?",
    english: "Where are you from?",
    words: ["I", "bɛ", "bɔ", "dugukolo", "min", "na", "?"],
    audio: "Ba-I_be_bo_dugukolo_min_na",
    category: 'Présentation',
    tags: ['origine', 'question']
  },

  // Loisirs et culture
  {
    original: "N bɛ sɛbɛn kalan",
    french: "Je lis le livre",
    english: "I am reading the book",
    words: ["N", "bɛ", "sɛbɛn", "kalan"],
    category: 'Loisirs et culture',
    tags: ['livre', 'lecture', 'présent']
  },

  {
    original: "A ka nɔgɔ ka nin kan dege",
    french: "Cette langue est facile à apprendre",
    english: "This language is easy to learn",
    words: ["A", "ka", "nɔgɔ", "ka", "nin", "kan", "dege"],
    audio: "Ba-A_ka_nogo_ka_nin_kan_dege",
    category: 'Loisirs et culture',
    tags: ['langue', 'apprentissage', 'facile']
  },


  {
    original: "N ye fɛn caman kalan bi",
    french: "J'ai beaucoup appris aujourd'hui",
    english: "I learned a lot today",
    words: ["N", "ye", "fɛn", "caman", "kalan", "bi"],
    audio: "Ba-N_ye_fen_caman_kalan_bi",
    category: 'Loisirs et culture',
    tags: ['livre', 'lecture', 'présent']
  },

  {
    original: "Sɛbɛn nin ka nyuman kosɛbɛ",
    french: "Ce livre est très bon",
    english: "This book is very good",
    words: ["Sɛbɛn", "nin", "ka", "nyuman", "kosɛbɛ"],
    category: 'Loisirs et culture',
    tags: ['livre', 'adjectif', 'adverbe']
  },
  {
    original: "N bɛ don fɛ",
    french: "Je veux danser",
    english: "I want to dance",
    words: ["N", "bɛ", "don", "fɛ"],
    category: 'Loisirs et culture',
    tags: ['danse', 'postposition', 'désir']
  },
  {
    original: "A ye sɛbɛn sɛbɛn dɔgɔkɛ kan",
    french: "Il/Elle a écrit sur la table",
    english: "He/She wrote on the table",
    words: ["A", "ye", "sɛbɛn", "sɛbɛn", "dɔgɔkɛ", "kan"],
    category: 'Loisirs et culture',
    tags: ['écriture', 'postposition', 'passé', 'table']
  },
  {
    original: "N bɛ kalali bankɛ kɔ",
    french: "Je joue derrière la maison",
    english: "I am playing behind the house",
    words: ["N", "bɛ", "kalali", "bankɛ", "kɔ"],
    category: 'Loisirs et culture',
    tags: ['jeu', 'postposition', 'maison']
  },

  {
    original: "An bɛna deen furake",
    french: "Nous soignerons l'enfant",
    english: "We will take care of the child",
    words: ["An", "bɛna", "deen", "furake"],
    audio: "Ba-An_bena_deen_furake",
    category: 'Urgences et santé',
    tags: ['soin', 'futur', 'enfant']
  },
  {
    original: "An bɛ deen furake",
    french: "Nous soignons l'enfant",
    english: "We are taking care of the child",
    words: ["An", "bɛ", "deen", "furake"],
    category: 'Urgences et santé',
    tags: ['soin', 'présent', 'enfant']
  },
  {
    original: "An ye deen furake",
    french: "Nous avons soigné l'enfant",
    english: "We took care of the child",
    words: ["An", "ye", "deen", "furake"],
    audio: "Ba-An_ye_deen_furake",
    category: 'Urgences et santé',
    tags: ['soin', 'passé', 'enfant']
  },
  {
    original: "Ka dɛmɛ !",
    french: "À l'aide !",
    english: "Help!",
    words: ["Ka", "dɛmɛ", "!"],
    category: 'Urgences et santé',
    tags: ['urgence', 'aide']
  },
  {
    original: "N bɛ dimi fɛ",
    french: "J'ai mal",
    english: "I am in pain",
    words: ["N", "bɛ", "dimi", "fɛ"],
    category: 'Urgences et santé',
    tags: ['douleur', 'postposition', 'santé']
  },
  {
    original: "N mago bɛ furake la",
    french: "J'ai besoin de soins",
    english: "I need medical care",
    words: ["N", "mago", "bɛ", "furake", "la"],
    category: 'Urgences et santé',
    tags: ['soin', 'besoin', 'postposition']
  },
  {
    original: "A bɛ bana",
    french: "Il/Elle est malade",
    english: "He/She is sick",
    words: ["A", "bɛ", "bana"],
    category: 'Urgences et santé',
    tags: ['maladie', 'adjectif', 'état']
  },
  {
    original: "I ka kɛnɛ wa ?",
    french: "Tu es en bonne santé ?",
    english: "Are you in good health?",
    words: ["I", "ka", "kɛnɛ", "wa", "?"],
    category: 'Urgences et santé',
    tags: ['santé', 'question']
  },
  {
    original: "N bɛ ji min bari n bɛ bana",
    french: "Je bois de l'eau parce que je suis malade",
    english: "I am drinking water because I am sick",
    words: ["N", "bɛ", "ji", "min", "bari", "n", "bɛ", "bana"],
    category: 'Urgences et santé',
    tags: ['conjonction causale', 'eau', 'maladie']
  },
  {
    original: "A taara ka ban, a kɛnɛra",
    french: "Après être parti, il/elle a guéri",
    english: "After leaving, he/she got better",
    words: ["A", "taara", "ka", "ban", "a", "kɛnɛra"],
    category: 'Urgences et santé',
    tags: ['postposition temporelle', 'passé', 'santé']
  },
  {
    original: "Fɔlɔ i ka ji min, ka kɔ i ka sunɔgɔ",
    french: "D'abord bois de l'eau, ensuite dors",
    english: "First drink some water, then sleep",
    words: ["Fɔlɔ", "i", "ka", "ji", "min", "ka", "kɔ", "i", "ka", "sunɔgɔ"],
    category: 'Urgences et santé',
    tags: ['adverbe ordre', 'conjonction', 'eau', 'sommeil']
  },
  {
    original: "N bɛna kɛnɛ sini",
    french: "Je serai en bonne santé demain",
    english: "I will be in good health tomorrow",
    words: ["N", "bɛna", "kɛnɛ", "sini"],
    category: 'Urgences et santé',
    tags: ['futur', 'santé', 'adverbe']
  },

  // Vie quotidienne


   {
    original: "N bɛna tabali kura san",
    french: "J'ai acheté une nouvelle table",
    english: "I bought a new table",
    words: ["N", "bɛna", "tabali", "kura", "san"],
    audio: "Ba-N_bena_tabali_kura_san",
    category: 'Présentation',
    tags: ['présentation', 'question']
  },


  {
    original: "Baarakɛtuma sera",
    french: "C'est l'heure du travail",
    english: "It's time to work",
    words: ["Baarakɛtuma", "sera"],
    audio: "Ba-Baaraketuma_sera",
    category: 'Vie quotidienne',
    tags: ['temps', 'question']
  },

    {
    original: "I bena ko tuma juman ?",
    french: "Quand vas tu te laver?",
    english: "When are you going to wash up?",
    words: ["I", "bena", "ko", "tuma", "juman","?"],
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },

  {
    original: "I fari be di ?",
    french: "Comment va ta santé",
    english: "How is your health?",
    words: ["I", "fari", "be", "di", "?"],
    audio: "Ba-I_fari_be_di",
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },

    {
    original: "A ka fisa bii",
    french: "Ca va mieux aujourd'hui",
    english: "It's better today",
    words: ["A", "ka", "fisa", "bii"],
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },

   {
    original: "I ye tobili ke tuma juman ?",
    french: "tu as fais la cuisine quand ?",
    english: "When did you cook?",
    words: ["I", "ye", "tobili", "ke", "tuma", "juman","?"],
    audio: "Ba-I_ye_tobili_ke_tuma_juman",
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },

  {
    original: "N kono fara",
    french: "Je suis rassasié",
    english: "I am full",
    words: ["N", "kono", "fara"],
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },

  {
    original: "I be tara yoro juman ?",
    french: "Où vas-tu ?",
    english: "Where are you going?",
    words: ["I", "be", "tara","yoro","juman","?"],
    audio: "Ba-I_be_tara_yoro_juman",
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },

   {
    original: "A bora sisan sisan",
    french: "Il vient juste de sortir",
    english: "He just went out",
    words: ["A", "bora", "sisan","sisan"],
    audio: "Ba-A_bora_sisan_sisan",
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },
  
  {
    original: "Jɔn bɛ dolo fɛ",
    french: "Qui veut de la bière",
    english: "Who wants some beer?",
    words: ["Jɔn", "bɛ", "dolo", "fɛ"],
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },

   {
    original: "Nodɔlɔ de ka di ne ye ",
    french: "Moi je préfère la bière de mil",
    english: "I prefer millet beer",
    words: ["Nodɔlɔ", "de", "ka", "di", "ne", "ye"],
    audio: "Ba-Nodolo_de_ka_di_ne_ye",
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },
{
  original: "Denmisenw don ?",
    french: "Comment vont tes enfant ?",
    english: "How are your children?",
    words: ["Denmisenw", "don"],
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },


  {
    original: "An bɛna dumuni kɛ sisan",
    french: "On va manger maintenant",
    english: "We're going to eat now",
    words: ["An", "bɛna", "dumuni", "kɛ","sisan"],
    category: 'Vie quotidienne',
    tags: ['nourriture', 'activité']
  },
  

   {
    original: "I bena mun tobi ?",
    french: "Que vas-tu cuisiner",
    english: "What are you going to cook?",
    words: ["I", "bena", "mun","tobi"],
    audio: "Ba-I_bena_mun_tobi",
    category: 'Vie quotidienne',
    tags: ['état', 'bien-être']
  },

   {
    original: "Nin dumuni nin be tobi cogo juman ?",
    french: "Comment prépare-t-on cette nourriture ?",
    english: "How is this food prepared?",
    words: ["Nin", "dumuni", "nin","be","tobi","cogo","juman"],
    audio: "Ba-Nin_dumuni_nin_be_tobi_cogo_juman",
    category: 'Vie quotidienne',
    tags: ['état', 'bien-être']
  },
  {
    original: "N bɛ bɔn",
    french: "Je suis fatigué(e)",
    english: "I am tired",
    words: ["N", "bɛ", "bɔn"],
    category: 'Vie quotidienne',
    tags: ['état', 'fatigue', 'verbe']
  },
  {
    original: "Tile min bɛ ?",
    french: "Quel jour sommes-nous ?",
    english: "What day is it?",
    words: ["Tile", "min", "bɛ", "?"],
    category: 'Vie quotidienne',
    tags: ['temps', 'question']
  },
  {
    original: "N bɛ ka sunɔgɔ",
    french: "Je vais dormir",
    english: "I am going to sleep",
    words: ["N", "bɛ", "ka", "sunɔgɔ"],
    category: 'Vie quotidienne',
    tags: ['activité', 'repos']
  },
  {
    original: "N kɔnɔ bɛ",
    french: "J'ai faim",
    english: "I am hungry",
    words: ["N", "kɔnɔ", "bɛ"],
    category: 'Vie quotidienne',
    tags: ['état', 'nourriture']
  },
  {
    original: "Waati min bɛ ?",
    french: "Quelle heure est-il ?",
    english: "What time is it?",
    words: ["Waati", "min", "bɛ", "?"],
    category: 'Vie quotidienne',
    tags: ['temps', 'question']
  },
 
  {
    original: "N bɛ sɛnɛ",
    french: "J'ai soif",
    english: "I am thirsty",
    words: ["N", "bɛ", "sɛnɛ"],
    category: 'Vie quotidienne',
    tags: ['état', 'besoin']
  },
  {
    original: "N bɛ ka taa so",
    french: "Je rentre à la maison",
    english: "I am going home",
    words: ["N", "bɛ", "ka", "taa", "so"],
    category: 'Vie quotidienne',
    tags: ['déplacement', 'maison']
  },
  {
    original: "I be min le ?",
    french: "Tu es où ?",
    english: "Where are you?",
    words: ["I", "be", "min", "le", "?"],
    audio: "Ba-I_be_min_le",
    category: 'Vie quotidienne',
    tags: ['question', 'localisation']
  },
  {
    original: "N bɛ baara kɛ",
    french: "Je travaille",
    english: "I am working",
    words: ["N", "bɛ", "baara", "kɛ"],
    category: 'Vie quotidienne',
    tags: ['travail', 'présent', 'activité']
  },
  {
    original: "I ma tila fɔlɔ wa?",
    french: "N'as tu pas encore fini?",
    english: "Haven't you finished yet?",
    words: ["I", "ma", "tila", "fɔlɔ", "wa", "?"],
    audio: "Ba-I_ma_tila_folo_wa",
    category: 'Vie quotidienne',
    tags: ['question', 'travail', 'temps']
  },
  {
    original: "N tilatɔ le ye nin ye",
    french: "Je viens juste de finir",
    english: "I just finished",
    words: ["N", "tilatɔ", "le", "ye", "nin", "ye"],
    category: 'Vie quotidienne',
    tags: ['travail', 'temps']
  },
  {
    original: "I bena don so wa?",
    french: "Vas-tu rentrer à la maison ?",
    english: "Are you going to go home?",
    words: ["I", "bena", "don", "so", "wa", "?"],
    audio: "Ba-I_bena_don_so_wa",
    category: 'Vie quotidienne',
    tags: ['question', 'maison', 'déplacement']
  },
  {
    original: "N bɛ tɛmɛ sugu la fɔlɔ",
    french: "Je passe d'abord au marché",
    english: "I'll stop by the market first",
    words: ["N", "bɛ", "tɛmɛ", "sugu", "la", "fɔlɔ"],
    audio: "Ba-N_be_teme_sugu_la_folo",
    category: 'Vie quotidienne',
    tags: ['déplacement', 'marché', 'courses']
  },
  {
    original: "I bena n kɔnɔ wa?",
    french: "Vas-tu m'attendre?",
    english: "Are you going to wait for me?",
    words: ["I", "bena", "n", "kɔnɔ", "wa", "?"],
    audio: "Ba-I_bena_n_kono_wa",
    category: 'Vie quotidienne',
    tags: ['question', 'attente']
  },
  {
    original: "Awɔ, i teliya ka na",
    french: "Oui, viens vite",
    english: "Yes, come quickly",
    words: ["Awɔ", "i", "teliya", "ka", "na"],
    audio: "Ba-Awo_i_teliya_ka_na",
    category: 'Vie quotidienne',
    tags: ['réponse', 'invitation', 'vitesse']
  },
  {
    original: "N ye ji min kunu sɔgɔma",
    french: "J'ai bu de l'eau hier matin",
    english: "I drank water yesterday morning",
    words: ["N", "ye", "ji", "min", "kunu", "sɔgɔma"],
    category: 'Vie quotidienne',
    tags: ['passé', 'eau', 'matin']
  },
  {
    original: "N bɛna malo dun sini",
    french: "Je mangerai du riz demain",
    english: "I will eat rice tomorrow",
    words: ["N", "bɛna", "malo", "dun", "sini"],
    category: 'Vie quotidienne',
    tags: ['futur', 'riz', 'nourriture']
  },
  {
    original: "N tɛ sogo fɛ",
    french: "Je ne veux pas de viande",
    english: "I don't want any meat",
    words: ["N", "tɛ", "sogo", "fɛ"],
    category: 'Vie quotidienne',
    tags: ['négation', 'viande', 'nourriture']
  },
  {
    original: "Kana sunɔgɔ sisan !",
    french: "Ne dors pas maintenant !",
    english: "Don't sleep now!",
    words: ["Kana", "sunɔgɔ", "sisan", "!"],
    category: 'Vie quotidienne',
    tags: ['impératif négatif', 'sommeil', 'temps']
  },
  {
    original: "N tun bɛ kɔngɔ tile min na",
    french: "J'avais faim ce jour-là",
    english: "I was hungry that day",
    words: ["N", "tun", "bɛ", "kɔngɔ", "tile", "min", "na"],
    category: 'Vie quotidienne',
    tags: ['imparfait', 'faim', 'temps']
  },
  {
    original: "A ye nɔnɔ tobi wula la",
    french: "Elle a préparé du lait le soir",
    english: "She prepared milk in the evening",
    words: ["A", "ye", "nɔnɔ", "tobi", "wula", "la"],
    category: 'Vie quotidienne',
    tags: ['passé', 'lait', 'soir', 'nourriture']
  },

  // Au marché
  {
    original: "Nin sɔngɔ ye joli ye ?",
    french: "Combien ça coûte ?",
    english: "How much does this cost?",
    words: ["Nin", "sɔngɔ", "ye", "joli", "ye", "?"],
    category: 'Au marché',
    tags: ['prix', 'achat']
  },

  {
    original: "Lɔgɔ be kofe yan",
    french: "Le marché est ici derriere",
    english: "The market is behind here",
    words: ["Logo", "be", "kofe", "yan"],
    audio: "Ba-Logo_be_kofe_yan",
    category: 'Au marché',
    tags: ['prix', 'achat']
  },

  {
    original: "Lɔgɔ be di ?",
    french: "Comment est le marché ?",
    english: "How is the market?",
    words: ["Lɔgɔ", "be", "di", "?"],
    audio: "Ba-Logo_be_di",
    category: 'Au marché',
    tags: ['prix', 'achat']
  },



   {
    original: "I b'a feere joli joli ?",
    french: "A combien le vends-tu ?",
    english: "How much are you selling it for?",
    words: ["I", "b'a", "feere", "joli", "joli", "?"],
    audio: "Ba-I_ba_feere_joli_joli",
    category: 'Au marché',
    tags: ['prix', 'achat']
  },


   {
    original: "I be joli bɔ a ra ?",
    french: "De combien peux-tu diminuer ?",
    english: "How much can you lower it by?",
    words: ["I", "be", "joli", "bɔ", "a", "ra", "?"],
    audio: "Ba-I_be_joli_bo_a_ra",
    category: 'Au marché',
    tags: ['prix', 'achat']
  },

  {
    original: "A karikari le ye nin ?",
    french: "C'est le dernier prix ?",
    english: "Is this your final price?",
    words: ["A", "karikari", "le", "ye", "nin", "?"],
    category: 'Au marché',
    tags: ['prix', 'achat']
  },


    {
    original: "Sugu be min ?",
    french: "Où est le marché",
    english: "Where is the market?",
    words: ["Sugu", "be", "min", "?"],
    audio: "Ba-Sugu_be_min",
    category: 'Au marché',
    tags: ['prix', 'achat']
  },

  {
    original: "N bena taa sugu la tuguni",
    french: "J'irai encore au marché",
    english: "I will go to the market again",
    words: ["N", "bena", "taa", "sugu", "la", "tuguni"],
    audio: "Ba-N_bena_taa_sugu_la_tuguni",
    category: 'Au marché',
    tags: ['prix', 'achat']
  },
  {
    original: "N bɛ ka san",
    french: "Je veux acheter",
    english: "I want to buy",
    words: ["N", "bɛ", "ka", "san"],
    category: 'Au marché',
    tags: ['achat', 'intention']
  },
  {
    original: "A sɔngɔ ka dɔgɔ",
    french: "C'est bon marché",
    english: "It's cheap",
    words: ["A", "sɔngɔ", "ka", "dɔgɔ"],
    category: 'Au marché',
    tags: ['prix', 'négociation']
  },
  {
    original: "A sɔngɔ ka gɛlɛn",
    french: "C'est très cher",
    english: "It's very expensive",
    words: ["A", "sɔngɔ", "ka", "gɛlɛn"],
    category: 'Au marché',
    tags: ['prix', 'négociation']
  },
  {
    original: "I bɛ se ka sɔngɔ dɔgɔya?",
    french: "Peux-tu baisser le prix ?",
    english: "Can you lower the price?",
    words: ["I", "bɛ", "se", "ka", "sɔngɔ", "dɔgɔya", "?"],
    category: 'Au marché',
    tags: ['prix', 'négociation']
  },
  {
    original: "N bɛ ɲini ka fɛn dɔ san",
    french: "Je cherche à acheter quelque chose",
    english: "I am looking to buy something",
    words: ["N", "bɛ", "ɲini", "ka", "fɛn", "dɔ", "san"],
    category: 'Au marché',
    tags: ['achat', 'recherche']
  },
  {
    original: "Nin ye mun ye ?",
    french: "Qu'est-ce que c'est que ça ?",
    english: "What is this?",
    words: ["Nin", "ye", "mun", "ye", "?"],
    category: 'Au marché',
    tags: ['question', 'information']
  },
  {
    original: "N tɛ a fɛ",
    french: "Je n'en veux pas",
    english: "I don't want it",
    words: ["N", "tɛ", "a", "fɛ"],
    category: 'Au marché',
    tags: ['refus', 'négociation']
  },

  // Voyages
  {
    original: "N bɛ ka taa",
    french: "Je vais partir",
    english: "I am going to leave",
    words: ["N", "bɛ", "ka", "taa"],
    category: 'Voyages',
    tags: ['déplacement', 'voyage']
  },
  {
    original: "Waati min bɛ ?",
    french: "Quelle heure est-il ?",
    english: "What time is it?",
    words: ["Waati", "min", "bɛ", "?"],
    category: 'Voyages',
    tags: ['temps', 'question']
  },
  {
    original: "N mago bɛ i dɛmɛ la",
    french: "J'ai besoin de ton aide",
    english: "I need your help",
    words: ["N", "mago", "bɛ", "i", "dɛmɛ", "la"],
    category: 'Voyages',
    tags: ['aide', 'assistance']
  },
  {
    original: "Nin sira bɛ taa min ?",
    french: "Où va cette route ?",
    english: "Where does this road go?",
    words: ["Nin", "sira", "bɛ", "taa", "min", "?"],
    category: 'Voyages',
    tags: ['direction', 'question']
  },
  {
    original: "N bɛ bankɛ ɲini",
    french: "Je cherche la maison",
    english: "I am looking for the house",
    words: ["N", "bɛ", "bankɛ", "ɲini"],
    category: 'Voyages',
    tags: ['recherche', 'maison', 'objet']
  },
  {
    original: "A janya kosɛbɛ",
    french: "C'est très loin",
    english: "It's very far",
    words: ["A", "janya", "kosɛbɛ"],
    category: 'Voyages',
    tags: ['distance', 'adverbe']
  },
  {
    original: "Sɔrɔbana bɛ bankɛ nɔfɛ",
    french: "La voiture est devant la maison",
    english: "The car is in front of the house",
    words: ["Sɔrɔbana", "bɛ", "bankɛ", "nɔfɛ"],
    category: 'Voyages',
    tags: ['postposition', 'voiture', 'maison', 'localisation']
  },
  {
    original: "An bɛna taa sini nka sisan tɛ",
    french: "Nous irons demain mais pas maintenant",
    english: "We will go tomorrow, but not now",
    words: ["An", "bɛna", "taa", "sini", "nka", "sisan", "tɛ"],
    category: 'Voyages',
    tags: ['conjonction', 'futur', 'adverbe', 'négation']
  },
  {
    original: "Taama dɔɔnin dɔɔnin, sira ka gɛrɛ",
    french: "Marche doucement, la route est difficile",
    english: "Walk slowly, the road is difficult",
    words: ["Taama", "dɔɔnin", "dɔɔnin", "sira", "ka", "gɛrɛ"],
    category: 'Voyages',
    tags: ['adverbe', 'route', 'adjectif']
  },
  {
    original: "Sani i ka taa, wele n",
    french: "Avant de partir, appelle-moi",
    english: "Before you go, call me",
    words: ["Sani", "i", "ka", "taa", "wele", "n"],
    category: 'Voyages',
    tags: ['postposition temps', 'déplacement', 'appel']
  },
  {
    original: "N bɛ sɔrɔbana kɔnɔ",
    french: "Je suis dans la voiture",
    english: "I am in the car",
    words: ["N", "bɛ", "sɔrɔbana", "kɔnɔ"],
    category: 'Voyages',
    tags: ['postposition', 'voiture', 'localisation']
  },
  {
    original: "Ni i bɛ sɔrɔla, na",
    french: "Si tu es disponible, viens",
    english: "If you're available, come",
    words: ["Ni", "i", "bɛ", "sɔrɔla", "na"],
    category: 'Voyages',
    tags: ['conjonction conditionnelle', 'déplacement']
  },

  // Famille et relations
  {
    original: "Nin ye mun ye ?",
    french: "Qui est-ce ?",
    english: "Who is this?",
    words: ["Nin", "ye", "mun", "ye", "?"],
    category: 'Famille et relations',
    tags: ['famille', 'question']
  },

   {
    original: "N donto lɔ",
    french: "Je viens de rentrer",
    english: "I just got back",
    words: ["N", "donto", "lɔ"],
    audio: "Ba-N_donto_lo",
    category: 'Famille et relations',
    tags: ['famille', 'question']
  },

  {
    original: "N tun be sinɔgɔra",
    french: "Je dormais",
    english: "I was sleeping",
    words: ["N", "tun", "be", "sinɔgɔra"],
    audio: "Ba-N_tun_be_sinogora",
    category: 'Famille et relations',
    tags: ['famille', 'question']
  },

    {
    original: "N be tagara boli",
    french: "Je pars faire du sport",
    english: "I'm going to exercise",
    words: ["N", "be", "tagara", "boli"],
    audio: "Ba-N_be_tagara_boli",
    category: 'Famille et relations',
    tags: ['famille', 'question']
  },

  {
    original: "Balimamuso joli b'i fɛ ?",
    french: "Combien de soeur as-tu ?",
    english: "How many sisters do you have?",
    words: ["Balimamuso", "joli", "b'i", "fɛ", "?"],
    category: 'Famille et relations',
    tags: ['famille', 'question']
  },


    {
    original: "I ka wulu bɛ ne lasiran",
    french: "Mon chien me fait peur",
    english: "My dog scares me",
    words: ["I", "ka", "wulu", "bɛ", "ne", "lasiran"],
    category: 'Famille et relations',
    tags: ['famille', 'question']
  },

   {
    original: "N ka wulu man jugu ",
    french: "Mon chien n'est pas méchant ",
    english: "My dog is not mean",
    words: ["N", "ka", "wulu", "man", "jugu"],
    audio: "Ba-N_ka_wulu_man_jugu",
    category: 'Famille et relations',
    tags: ['famille', 'question']
  },


  {
    original: "N ka jakuma te fosi ke dununi kɔ",
    french: "Mon chat ne fait que manger",
    english: "My cat does nothing but eat",
    words: ["N", "ka", "jakuma", "te", "fosi", "ke", "dununi", "kɔ"],
    category: 'Famille et relations',
    tags: ['famille', 'question']
  },

  {
    original: "Nin den ye N ka den ye",
    french: "Cet enfant est mon enfant",
    english: "This child is my child",
    words: ["Nin", "den", "ye", "N", "ka", "den", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'possessif', 'identification']
  },
  {
    original: "A ka bamuso ye dɔɔrɔman ye",
    french: "Sa mère est belle",
    english: "His/Her mother is beautiful",
    words: ["A", "ka", "bamuso", "ye", "dɔɔrɔman", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'description', 'possessif']
  },
  {
    original: "N den ye nin ye",
    french: "C'est mon enfant",
    english: "This is my child",
    words: ["N", "den", "ye", "nin", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'enfant']
  },
  {
    original: "N fa ye nin ye",
    french: "C'est mon père",
    english: "This is my father",
    words: ["N", "fa", "ye", "nin", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'parent']
  },
  {
    original: "N na ye nin ye",
    french: "C'est ma mère",
    english: "This is my mother",
    words: ["N", "na", "ye", "nin", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'parent']
  },
  {
    original: "N bɛɛre ye nin ye",
    french: "C'est ma sœur",
    english: "This is my sister",
    words: ["N", "bɛɛre", "ye", "nin", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'fratrie']
  },
  {
    original: "N kɔrɔ ye nin ye",
    french: "C'est mon frère",
    english: "This is my brother",
    words: ["N", "kɔrɔ", "ye", "nin", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'fratrie']
  },
  {
    original: "N furow bɛ joli ye?",
    french: "Combien d'épouses as-tu ?",
    english: "How many wives do you have?",
    words: ["N", "furow", "bɛ", "joli", "ye", "?"],
    category: 'Famille et relations',
    tags: ['famille', 'mariage', 'question']
  },
  {
    original: "N denw bɛ joli ye ?",
    french: "Combien d'enfants as-tu ?",
    english: "How many children do you have?",
    words: ["N", "denw", "bɛ", "joli", "ye", "?"],
    category: 'Famille et relations',
    tags: ['famille', 'enfants', 'question']
  },
  {
    original: "Jɔɔn ye nin ye ?",
    french: "Qui est-ce ?",
    english: "Who is this?",
    words: ["Jɔɔn", "ye", "nin", "ye", "?"],
    category: 'Famille et relations',
    tags: ['interrogatif', 'identification']
  },
  {
    original: "N ka mamamuso bɛ kɛnɛ",
    french: "Ma grand-mère va bien",
    english: "My grandmother is doing well",
    words: ["N", "ka", "mamamuso", "bɛ", "kɛnɛ"],
    category: 'Famille et relations',
    tags: ['famille', 'grand-mère', 'possessif']
  },
  {
    original: "An ka dɔgɔcɛ surun ye",
    french: "Notre frère cadet est intelligent",
    english: "Our younger brother is smart",
    words: ["An", "ka", "dɔgɔcɛ", "surun", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'frère', 'possessif', 'description']
  },
  {
    original: "A ka mamacɛ ye kɔrɔcɛ ye",
    french: "Son grand-père est l'aîné",
    english: "His/Her grandfather is the eldest",
    words: ["A", "ka", "mamacɛ", "ye", "kɔrɔcɛ", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'grand-père', 'identification']
  },
  {
    original: "Mɔgɔ min bɛ yan, a ye N fa ye",
    french: "La personne qui est ici, c'est mon père",
    english: "The person who is here is my father",
    words: ["Mɔgɔ", "min", "bɛ", "yan", "a", "ye", "N", "fa", "ye"],
    category: 'Famille et relations',
    tags: ['relatif', 'père', 'identification']
  },
  {
    original: "U ka denmuso naani ye",
    french: "Ils ont quatre filles",
    english: "They have four daughters",
    words: ["U", "ka", "denmuso", "naani", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'nombre', 'possessif']
  },

  // Phrases supplémentaires
  {
    original: "N bɛna nakɔ san sugu la",
    french: "Je vais acheter des légumes au marché",
    english: "I am going to buy vegetables at the market",
    words: ["N", "bɛna", "nakɔ", "san", "sugu", "la"],
    category: 'Au marché',
    tags: ['achat', 'légumes', 'marché', 'futur']
  },

   {
    original: "I ye nin fani san joli ? ",
    french: "Combien as-tu acheté ce vêtement ?",
    english: "How much did you pay for this piece of clothing?",
    words: ["I", "ye", "nin", "fani", "san", "joli", "?"],
    audio: "Ba-I_ye_nin_fani_san_joli",
    category: 'Au marché',
    tags: ['achat', 'vêtement', 'marché', 'futur']
  },

   {
    original: "Dɔrɔme keme naani  ",
    french: "2000 francs CFA",
    english: "2000 CFA francs",
    words: ["Dɔrɔme", "keme", "naani"],
    audio: "Ba-Dorome_keme_naani",
    category: 'Au marché',
    tags: ['achat', 'vêtement', 'marché', 'futur']
  },

    {
    original: "Mangorow joli tora ?",
    french: "Combien de mangues reste-t-il ?",
    english: "How many mangoes are left?",
    words: ["Mangorow", "joli", "tora", "?"],
    audio: "Ba-Mangorow_joli_tora",
    category: 'Au marché',
    tags: ['achat', 'légumes', 'marché', 'futur']
  },

    {
    original: "Deen segin le tora",
    french: "Il en reste 8",
    english: "There are 8 left",
    words: ["Deen", "segin", "le", "tora"],
    audio: "Ba-Deen_seegin_le_tora",
    category: 'Au marché',
    tags: ['achat', 'légumes', 'marché', 'futur']
  },
  {
    original: "Sini an bena taga dugu ra",
    french: "Demain nous irons dans une ville",
    english: "Tomorrow we will go to a town",
    words: ["Sini", "an", "bena", "taga", "dugu", "ra"],
    audio: "Ba-Sini_an_bena_taga_dugu_ra",
    category: 'Voyages',
    tags: ['voyage', 'futur', 'déplacement', 'ville']
  },
  {
    original: "Ziditi tagara a ka dugu ra",
    french: "Judith est allée dans sa ville natale",
    english: "Judith went to her hometown",
    words: ["Ziditi", "tagara", "a", "ka", "dugu", "ra"],
    audio: "Ba-Ziditi_tagara_a_ka_dugu_ra",
    category: 'Voyages',
    tags: ['voyage', 'passé', 'origine', 'famille']
  },
  {
    original: "N ka faa ye kɔrɔn ye",
    french: "Mon père est vieux",
    english: "My father is old",
    words: ["N", "ka", "faa", "ye", "kɔrɔn", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'père', 'description']
  },
  {
    original: "I denw be min ?",
    french: "Ou sont tes enfants ?",
    english: "Where are your children?",
    words: ["I", "denw", "be", "min", "?"],
    category: 'Famille et relations',
    tags: ['famille', 'enfant', 'parent', 'filiation']
  },
  {
    original: "N ma sogo san kunu",
    french: "Je n'ai pas acheté de viande hier",
    english: "I didn't buy meat yesterday",
    words: ["N", "ma", "sogo", "san", "kunu"],
    category: 'Au marché',
    tags: ['négation', 'passé', 'viande', 'achat']
  },
  {
    original: "Jɔɔn be sogo feere yan ?",
    french: "Qui vend de la viande ici ?",
    english: "Who sells meat here?",
    words: ["Jɔɔn", "be", "sogo", "feere", "yan", "?"],
    audio: "Ba-Joon_be_sogo_feere_yan",
    category: 'Au marché',
    tags: ['question', 'viande', 'vendeur', 'commerce']
  },

   {
    original: "N be taa sugu la",
    french: "Je vais au marché",
    english: "I am going to the market",
    words: ["N", "be", "taa", "sugu", "la"],
    audio: "Ba-N_be_taa_sugu_la",
    category: 'Au marché',
    tags: ['déplacement', 'marché', 'présent']
  },
  {
    original: "U taara sugu la sɔgɔma",
    french: "Ils sont allés au marché le matin",
    english: "They went to the market in the morning",
    words: ["U", "taara", "sugu", "la", "sɔgɔma"],
    category: 'Au marché',
    tags: ['passé', 'marché', 'matin']
  },
  {
    original: "I bɛna malo san tile min?",
    french: "Quel jour vas-tu acheter du riz ?",
    english: "What day are you going to buy rice?",
    words: ["I", "bɛna", "malo", "san", "tile", "min", "?"],
    category: 'Au marché',
    tags: ['futur', 'riz', 'question', 'temps']
  },
  {
    original: "Nin ji sɔngɔ ye joli ye ?",
    french: "Combien coûte cette eau ?",
    english: "How much does this water cost?",
    words: ["Nin", "ji", "sɔngɔ", "ye", "joli", "ye", "?"],
    category: 'Au marché',
    tags: ['prix', 'eau', 'question']
  },
  {
    original: "N tɛna namasa san tile min bɛ",
    french: "Je n'achèterai pas de bananes aujourd'hui",
    english: "I will not buy bananas today",
    words: ["N", "tɛna", "namasa", "san", "tile", "min", "bɛ"],
    category: 'Au marché',
    tags: ['négation', 'futur', 'banane', 'nourriture']
  },

   {
    original: "A donna so",
    french: "Elle est rentrée à la maison !",
    english: "She went home!",
    words: ["A", "donna", "so"],
    audio: "Ba-A_donna_so",
    category: 'Vie quotidienne',
    tags: ['maison', 'négation', 'parole']
  },

  {
    original: "Kana kuma !",
    french: "Ne parle pas !",
    english: "Don't talk!",
    words: ["Kana", "kuma", "!"],
    audio: "Ba-Kana_kuma",
    category: 'Vie quotidienne',
    tags: ['ordre', 'négation', 'parole']
  },
  {
    original: "N ka kɔrɔmuso ye muso dɔɔrɔman ye",
    french: "Ma sœur aînée est une belle femme",
    english: "My older sister is a beautiful woman",
    words: ["N", "ka", "kɔrɔmuso", "ye", "muso", "dɔɔrɔman", "ye"],
    category: 'Famille et relations',
    tags: ['famille', 'sœur', 'description', 'possessif']
  },
  {
    original: "N bɛ kalan dɔɔnin dɔɔnin",
    french: "J'étudie peu à peu",
    english: "I am studying little by little",
    words: ["N", "bɛ", "kalan", "dɔɔnin", "dɔɔnin"],
    category: 'Loisirs et culture',
    tags: ['étude', 'adverbe', 'progressivité']
  },
  {
    original: "A tɛ kalan fɛ nka a bɛ baara kɛ",
    french: "Il ne veut pas étudier mais il travaille",
    english: "He doesn't want to study, but he works",
    words: ["A", "tɛ", "kalan", "fɛ", "nka", "a", "bɛ", "baara", "kɛ"],
    category: 'Loisirs et culture',
    tags: ['conjonction', 'négation', 'étude', 'travail']
  },
  {
    original: "Fɔlɔ i ka kalan, ka kɔ i ka don",
    french: "D'abord étudie, ensuite danse",
    english: "First study, then dance",
    words: ["Fɔlɔ", "i", "ka", "kalan", "ka", "kɔ", "i", "ka", "don"],
    category: 'Loisirs et culture',
    tags: ['adverbe ordre', 'conjonction', 'étude', 'danse']
  },
  {
    original: "Patirisiya ye sunguru ye",
    french: "Patricia est jolie",
    english: "Patricia is pretty",
    words: ["Patirisiya", "ye", "sunguru", "ye"],
    audio: "Ba-Patirisiya_ye_sunguru_ye",
    category: 'Famille et relations',
    tags: ['description', 'beauté', 'compliment']
  },
  {
    original: "Tidiyani kɛra kanbele ye",
    french: "Tidiani est devenu un jeune homme",
    english: "Tidiani became a young man",
    words: ["Tidiyani", "kɛra", "kanbele", "ye"],
    audio: "Ba-Tidiyani_kera_kanbele_ye",
    category: 'Famille et relations',
    tags: ['âge', 'croissance', 'jeunesse', 'changement']
  },
  {
    original: "Amɛdi ye fatumata facɛ ye",
    french: "Ahmed et Fatoumata se sont mariés",
    english: "Ahmed and Fatoumata got married",
    words: ["Amɛdi", "ye", "fatumata", "facɛ", "ye"],
    audio: "Ba-Amedi_ye_fatumata_face_ye",
    category: 'Famille et relations',
    tags: ['mariage', 'union', 'famille', 'cérémonie']
  },
  {
    original: "N bɛ sɛbɛn kɛ sisan",
    french: "J'écris maintenant",
    english: "I am writing now",
    words: ["N", "bɛ", "sɛbɛn", "kɛ", "sisan"],
    category: 'Loisirs et culture',
    tags: ['écriture', 'adverbe', 'présent']
  },
  {
    original: "Telefɔni bɛ dɔgɔkɛ kan",
    french: "Le téléphone est sur la table",
    english: "The phone is on the table",
    words: ["Telefɔni", "bɛ", "dɔgɔkɛ", "kan"],
    category: 'Loisirs et culture',
    tags: ['téléphone', 'postposition', 'table', 'localisation']
  },
  {
    original: "N bɛ kalan bari n kanu a la",
    french: "J'étudie parce que je l'aime",
    english: "I study because I love it",
    words: ["N", "bɛ", "kalan", "bari", "n", "kanu", "a", "la"],
    category: 'Loisirs et culture',
    tags: ['conjonction causale', 'étude', 'amour']
  },
  {
    original: "Hali a bɛ bɔn, a bɛ baara kɛ tuma bɛɛ",
    french: "Même s'il est fatigué, il travaille toujours",
    english: "Even though he's tired, he always works",
    words: ["Hali", "a", "bɛ", "bɔn", "a", "bɛ", "baara", "kɛ", "tuma", "bɛɛ"],
    category: 'Loisirs et culture',
    tags: ['conjonction concessive', 'adverbe', 'travail']
  },
  {
    original: "N bɛ seli tile bɛɛ sɔgɔma",
    french: "Je prie chaque matin",
    english: "I pray every morning",
    words: ["N", "bɛ", "seli", "tile", "bɛɛ", "sɔgɔma"],
    category: 'Loisirs et culture',
    tags: ['prière', 'adverbe fréquence', 'matin']
  },
  {
    original: "Sɛbɛnkɛlan bɛ dɔnniya kɛrɛfɛ",
    french: "Le crayon est à côté de la chaise",
    english: "The pencil is next to the chair",
    words: ["Sɛbɛnkɛlan", "bɛ", "dɔnniya", "kɛrɛfɛ"],
    category: 'Loisirs et culture',
    tags: ['crayon', 'postposition', 'chaise', 'localisation']
  },
  {
    original: "N bɛ kalan walima n bɛ don",
    french: "J'étudie ou je danse",
    english: "I study or I dance",
    words: ["N", "bɛ", "kalan", "walima", "n", "bɛ", "don"],
    category: 'Loisirs et culture',
    tags: ['conjonction alternative', 'étude', 'danse']
  },
  {
    original: "N bɛ nisɔndiya bari n bɛ kalan",
    french: "Je suis content parce que j'étudie",
    english: "I am happy because I study",
    words: ["N", "bɛ", "nisɔndiya", "bari", "n", "bɛ", "kalan"],
    category: 'Loisirs et culture',
    tags: ['conjonction causale', 'émotion', 'étude']
  }
];

// Fonctions utilitaires
export const getSentencesByCategory = (category: keyof typeof SENTENCE_CATEGORIES) =>
  sentencesToConstruct.filter(sentence => sentence.category === category);

export const getSentencesByTags = (tags: string[]) =>
  sentencesToConstruct.filter(sentence => 
    tags.some(tag => sentence.tags.includes(tag))
  );

export const getCategories = () => SENTENCE_CATEGORIES;

export default sentencesToConstruct;
